/**
 * Registers a directive for handling CMS preference textarea elements.
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerCmsPreferenceTextareaDirective(module) {
    module.directive('cmsPreferenceTextarea', function($compile, $bridges, TaskDataService) {
        /**
         * Defines the directive for the CMS preference textarea.
         * @returns {object} The directive definition object.
         */
        return {
            restrict: 'EA', // Restricts the directive to elements and attributes.
            replace: true, // Replaces the HTML element with the template.
            scope: {
                theKey: '=key', // Binds the key attribute to the directive's scope.
                prefData: '=data', // Binds the data attribute to the directive's scope.
                parentScope: '=scope' // Binds the scope attribute to the directive's scope.
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-textarea.html", // Specifies the URL of the template to use.
            controller: function($scope, $rootScope, $signals, $interval) {
                // Initializes the data for the scope.
                $scope.data = $scope.prefData[$scope.theKey];
                // Generates a random ID for the element.
                $scope.randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                // SMELL: Dependency on Math.random is not ideal for generating UUIDs. Consider a different approach.
            }
        };
    });
}